export class LazyPromise {
    constructor(executor) {
        this.promiseExecutor = executor;
    }
    then(onfulfilled, onrejected) {
        if (!this.promise) {
            this.promise = new Promise(this.promiseExecutor);
        }
        return this.promise.then(onfulfilled, onrejected);
    }
    reset() {
        this.promise = null;
    }
}
//# sourceMappingURL=lazy-promise.js.map